import React from 'react';
import { Dialog, Box, Typography, Button, CircularProgress } from '@mui/material';

export function DeclineInvitationModal({
    open,
    onClose,
    onConfirm,
    propertyName,
    loading = false
}) {
    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    border: '1px solid #f0f0f0',
                    maxWidth: '360px',
                    opacity: loading ? 0.5 : 1,
                    pointerEvents: loading ? 'none' : 'auto',
                    position: 'relative'
                }
            }}
        >
            {loading && (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <CircularProgress />
                </Box>
            )}

            <Box sx={{ height: '30px' }} />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                    px: '20px',
                    pb: '20px'
                }}
            >
                <Typography
                    sx={{
                        fontSize: '16px',
                        color: '#212322',
                        textAlign: 'center',
                        width: '230px',
                        lineHeight: '22px',
                        wordBreak: 'break-word'
                    }}
                >
                    <span style={{ fontWeight: 400 }}>Decline invitation to </span>
                    <span style={{ fontWeight: 600 }}>{propertyName}</span>
                    <span style={{ fontWeight: 400 }}>?</span>
                </Typography>

                <Typography
                    sx={{
                        fontWeight: 400,
                        fontSize: '13px',
                        color: '#212322',
                        textAlign: 'center',
                        lineHeight: 'normal'
                    }}
                >
                    Are you sure that you wish to proceed?
                </Typography>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    height: '0.914613px',
                    bgcolor: '#f0f0f0'
                }}
            />

            <Box
                sx={{
                    display: 'flex',
                    gap: '10px',
                    p: '15px'
                }}
            >
                <Button
                    variant="outlined"
                    onClick={onClose}
                    fullWidth
                    disabled={loading}
                    sx={{
                        color: 'text.primary',
                        borderColor: 'grey.300',
                        fontSize: 13,
                        textTransform: 'none',
                        borderRadius: 1,
                        boxShadow: '0px 2px 0px 0px rgba(0,0,0,0.02)',
                        '&:hover': {
                            borderColor: 'grey.400',
                            bgcolor: 'grey.50',
                            color: 'text.primary'
                        }
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={onConfirm}
                    fullWidth
                    disabled={loading}
                    sx={{
                        bgcolor: '#ff2522',
                        color: 'white',
                        fontSize: 13,
                        textTransform: 'none',
                        borderRadius: 1,
                        '&:hover': {
                            bgcolor: '#d91e1c'
                        }
                    }}
                >
                    Confirm
                </Button>
            </Box>
        </Dialog>
    );
}